import { FuelButton } from '@frete.com/fuel-react';
import { BOTTOM_MENU_HEIGHT } from 'constants/styled.contants';
import styled, { css } from 'styled-components';

const BOTTOM_SPACE = 117;

export const BackToTopButton = styled(FuelButton)<{
  $hasBackToTopButton: boolean;
  $left: number;
}>`
  position: fixed;
  top: 104%;
  transition: transform 0.2s linear;
  left: calc(${({ $left }) => $left}px - 16px);
  z-index: 9;

  ${({ $hasBackToTopButton }) =>
    $hasBackToTopButton &&
    css`
      transform: translateY(-${BOTTOM_SPACE}px);
    `};

  ${({ theme, $left, $hasBackToTopButton }) => css`
    @media screen and (max-width: ${theme.breakpoint.md.maxWidth}) {
      left: calc(${$left}px - 64px);

      ${$hasBackToTopButton &&
      `
      transform: translateY(-${BOTTOM_SPACE + parseFloat(BOTTOM_MENU_HEIGHT)}px);
      `}
    }
  `}

  &::part(button) {
    background: ${({ theme }) => theme.color.background.neutral.default};
  }
`;
